import createIcon from '../../createIcon';

/**
 * @component @name SwitchVideo
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggOS41VjZDMTggNS40NSAxNy41NSA1IDE3IDVIM0MyLjQ1IDUgMiA1LjQ1IDIgNlYxOEMyIDE4LjU1IDIuNDUgMTkgMyAxOUgxN0MxNy41NSAxOSAxOCAxOC41NSAxOCAxOFYxNC41TDIyIDE4LjVWNS41TDE4IDkuNVpNMTMgMTUuNVYxM0g3VjE1LjVMMy41IDEyTDcgOC41VjExSDEzVjguNUwxNi41IDEyTDEzIDE1LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SwitchVideo = createIcon('SwitchVideo', [
  [
    'path',
    {
      d: 'M18 9.5V6C18 5.45 17.55 5 17 5H3C2.45 5 2 5.45 2 6V18C2 18.55 2.45 19 3 19H17C17.55 19 18 18.55 18 18V14.5L22 18.5V5.5L18 9.5ZM13 15.5V13H7V15.5L3.5 12L7 8.5V11H13V8.5L16.5 12L13 15.5Z',
      key: '1gqclu',
    },
  ],
]);

export default SwitchVideo;
